import axios from "axios";
import { CONTAINER_UPDATE_VERSION, RESET, CONTAINER_TOGGLE_MENU, CONTAINER_LOADING, CURRENT_MODULE, MODULE_LIST, CURRENT_CONFIG, PUBLIC_SETTINGS } from "./Events";

import '../utils/axiosDefaults';

export function getVersion() {
  return function (dispatch) {

    const request = axios.get(`/Authentication/GetVersion`);

    request
      .then(response => {
        dispatch({ type: CONTAINER_UPDATE_VERSION, payload: response.data });
      })
      .catch(() => {

      })
  }
}

export function resetReducer() {
  return function (dispatch) {
    dispatch({ type: RESET, payload: null });
  }
}

export function getModules() {
  return function (dispatch) {

    const request = axios.get(`/Module/ListActive`);

    request
      .then(response => {
        dispatch({ type: MODULE_LIST, payload: response.data });
      })
      .catch(() => {
      });
  };
}

export function getConfig() {
  return function (dispatch) {

    const request = axios.get(`/PublicConfig/Get`);

    request
      .then(response => {
        // DEBUG: confirma o que veio do backend pra rastrear mapGoogleMapsKey
        // eslint-disable-next-line no-console
        console.log('[Container.getConfig] response.data.mapGoogleMapsKey=', response?.data?.mapGoogleMapsKey, ' full=', response?.data);
        dispatch({ type: CURRENT_CONFIG, payload: response.data });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('[Container.getConfig] FAILED', err?.message, err?.response?.status);
      });
  };
}

export function getPublicSettings(callback) {
  return function (dispatch) {
    axios.get(`/PublicSettings/GetSettings`)
      .then(response => {
        dispatch({ type: PUBLIC_SETTINGS, payload: response.data });
        if(callback) {
          callback()
        }
      })
      .catch(() => {
      });
  };
}


export function toggleMenu() {
  return function (dispatch) {
    dispatch({ type: CONTAINER_TOGGLE_MENU });
  };
}

export function startLoading() {
  return function (dispatch) {
    dispatch({ type: CONTAINER_LOADING, payload: true });
  };
}

export function endLoading() {
  return function (dispatch) {
    dispatch({ type: CONTAINER_LOADING, payload: false });
  };
}

export function clearCurrentModule() {
  return function (dispatch) {
    dispatch({ type: CURRENT_MODULE, payload: null });
  };
}

export function setCurrentModule(module) {
  return function (dispatch) {
    dispatch({ type: CURRENT_MODULE, payload: module });
  };
}
